import Modal from 'react-modal';
import * as React from 'react';
import { DriverRegistrationPortalNoAuthService } from '@gen/driverRegistration/driverRegistrationPortalNoAuth';
import { setFormStep } from 'app/redux/form/formActions';
import { reloadFormData } from '../redux/form/formThunk';
import { clearInvalidStepError } from '../redux/notification/notificationActions';
import { getInvalidStepError } from '../redux/notification/notificationsSelectors';
import { getTranslations } from '../redux/form/formSelectors';
import { useDispatch, useSelector } from '../redux/store';

export const InvalidStepDialog: React.FC = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getInvalidStepError);
  const translations = useSelector(getTranslations);

  const handleReturnToStart = async () => {
    dispatch(clearInvalidStepError());
    await dispatch(reloadFormData());
    dispatch(
      setFormStep(
        DriverRegistrationPortalNoAuthService.DriverRegistrationLogLastStep
          .STEP2
      )
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={handleReturnToStart}
      appElement={document.getElementById('appWithStore') as HTMLElement}
      className="fixed top-1/2 left-1/2 right-auto bottom-auto border-0 bg-white rounded outline-none shadow-lg p-8 w-[90%] max-w-md"
      overlayClassName="fixed top-0 bottom-0 left-0 right-0 bg-gray-700 bg-opacity-75 z-50"
      style={{
        content: {
          transform: 'translate(-50%,-50%)',
        },
      }}
    >
      <h2 className="text-xl font-bold text-center mb-4">
        {translations.invalid_step_dialog.title}
      </h2>
      <p className="text-center text-gray-800 mb-6">
        {translations.invalid_step_dialog.content}
      </p>
      <div className="flex justify-center">
        <button
          type="button"
          onClick={handleReturnToStart}
          className="bg-black text-white font-medium py-3 px-8 rounded-full hover:bg-gray-800 transition-colors"
        >
          {translations.invalid_step_dialog.button}
        </button>
      </div>
    </Modal>
  );
};
